import { Card, CardContent } from "@/components/ui/card";
import { Briefcase, Bot, Target, Brain, Cpu, Shield } from "lucide-react";

export const ServicesGrid = () => {
  const services = [
    {
      icon: <Briefcase className="h-8 w-8 text-blue-500" />,
      title: "Business Strategy",
      description: "Develop comprehensive digital strategies tailored to your service business needs."
    },
    {
      icon: <Bot className="h-8 w-8 text-blue-500" />,
      title: "Client Acquisition",
      description: "Deploy AI-powered lead generation and qualification systems to identify and attract ideal clients automatically."
    },
    {
      icon: <Target className="h-8 w-8 text-blue-500" />,
      title: "Market Positioning",
      description: "Leverage AI market analysis and competitor intelligence to optimize your positioning and reach."
    },
    {
      icon: <Brain className="h-8 w-8 text-blue-500" />,
      title: "Performance Analytics",
      description: "Harness AI-driven insights and predictive analytics to forecast trends and optimize business decisions."
    },
    {
      icon: <Cpu className="h-8 w-8 text-blue-500" />,
      title: "Process Automation",
      description: "Implement intelligent automation with AI agents to streamline workflows and enhance operational efficiency."
    },
    {
      icon: <Shield className="h-8 w-8 text-blue-500" />,
      title: "Client Retention",
      description: "Utilize AI-powered engagement tools and predictive analytics to strengthen client relationships and reduce churn."
    }
  ];

  return (
    <section className="py-20 px-4 bg-gradient-to-b from-white via-blue-50 to-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl font-bold text-center text-blue-900 mb-4">
          Comprehensive Business Solutions
        </h2>
        <p className="text-xl text-blue-600 text-center mb-12 max-w-3xl mx-auto">
          Transform your service business with our suite of AI-powered solutions designed to drive growth and efficiency.
        </p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card key={index} className="group hover:shadow-2xl transition-all duration-300 border-none bg-gradient-to-br from-white to-blue-50">
              <CardContent className="p-8">
                <div className="mb-6 transform group-hover:scale-110 transition-transform duration-300">
                  {service.icon}
                </div>
                <h3 className="text-2xl font-semibold mb-4 text-blue-900 group-hover:text-blue-700 transition-colors">
                  {service.title}
                </h3>
                <p className="text-blue-600">{service.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};